import {query} from 'api';
import PropTypes from 'prop-types';
import HomepageRecettes from './homepageRecettes';
import HomepageHeadline from './homepageHeadline';
import HomepageArticles from './homepageArticles';
import HomepageFormations from './homepageFormations';
import HomepageGifts from './homepageGifts';
import HomepageInformation from './homepageInformation';
import {Button, colors, Hr} from 'ui';
import NotificationBell from 'ui/NotificationBell';
import {Container, HeaderRow, LogoWhite} from './styles';
import PointsBlock from './homepageGifts/pointsBlock';

//: {club_geste_technique, club_recette_video, club_recette}
const Homepage = ({data}) => {
  // TODO remove this when loadingIf is baked into query.js
  if (!data?.acf) return null;
  const {
    club_geste_technique,
    club_recette_video,
    club_recette,
    club_article_first,
    club_article_second,
    club_article_third,
  } = data.acf;

  return (
    <Container>
      <HeaderRow>
        <LogoWhite />
        <NotificationBell parent="homepage" />
      </HeaderRow>
      <HomepageHeadline />
      <div
        style={{
          backgroundColor: colors.darkBrown,
          paddingBottom: 24,
          display: 'flex',
          flexDirection: 'column',
        }}>
        <div
          style={{
            margin: '0 24px',
          }}>
          <PointsBlock />
        </div>
        <Button color="white" style={{margin: 'auto', marginTop: 24}} to="/gifts">
          Commander un cadeau
        </Button>
      </div>
      <Hr />
      <HomepageArticles
        posts={[
          {type: 'articles', id: club_article_first.ID},
          {type: 'articles', id: club_article_second.ID},
          {type: 'articles', id: club_article_third.ID},
        ]}
      />
      <HomepageRecettes
        posts={[
          {type: 'conseils', id: club_geste_technique},
          {type: 'recette_club', id: club_recette_video},
          {type: 'recette_club', id: club_recette},
        ]}
      />
      <HomepageInformation />
    </Container>
  );
};

Homepage.propTypes = {
  data: PropTypes.object,
};

export default Homepage |> query('getHomepage', {loadingFullWidth: true});
